export default "__VITE_ASSET__EqiAUza0__"